import { FilePlus } from 'lucide-react';

import { ContentPanelMode, selectNavigation, setContentPanelMode, useAppDispatch, useAppSelector } from '@state';
import { lang } from '../../lang';
import { Feature, FeatureHoookParams } from '..';

type SubmissionFeatureParams = FeatureHoookParams;
export const useAddSubmissionFeature = (_params: SubmissionFeatureParams = {}): Feature<string> => {
	const appNav = useAppSelector(selectNavigation);
	const dispatch = useAppDispatch();

	const [disabled, tooltip] = (() => {
		if (!appNav.email) return [true, lang.islandSubmission.tooltip.noCustomer];
		if (!appNav.draft) return [true, lang.islandSubmission.tooltip.readonlyActive];
		return [false, lang.islandSubmission.tooltip.addDesign];
	})();

	return {
		name: 'add-submission',
		label: lang.promotionalSku.label.add,
		shortcut: '',
		tooltip,
		icon: (props) => <FilePlus {...props}/>,
		disabled,
		value: '',
		hidden: false,
		handler: () => {
			dispatch(setContentPanelMode(ContentPanelMode.NewSubmission));
		}
	};
};
